// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/profile/v1/profile_api.proto (package gdx.profile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchGetHomelessProfileLocationRequest, BatchGetHomelessProfileLocationResponse, BatchGetProfileInfoRequest, BatchGetProfileInfoResponse, BatchGetProfilePreviewRequest, BatchGetProfilePreviewResponse, BatchGetProfileTagsRequest, BatchGetProfileTagsResponse, GetHomelessProfileLocationRequest, GetHomelessProfileLocationResponse, GetProfileInfoRequest, GetProfileInfoResponse, GetProfilePreviewRequest, GetProfilePreviewResponse, GetUserIDRequest, GetUserIDResponse } from "./profile_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Implements all profile related APIs.
 *
 * @generated from service gdx.profile.v1.ProfileAPI
 */
export const ProfileAPI = {
  typeName: "gdx.profile.v1.ProfileAPI",
  methods: {
    /**
     * Returns single user profile preview.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.GetProfilePreview
     */
    getProfilePreview: {
      name: "GetProfilePreview",
      I: GetProfilePreviewRequest,
      O: GetProfilePreviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns multiple user profile previews.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.BatchGetProfilePreview
     */
    batchGetProfilePreview: {
      name: "BatchGetProfilePreview",
      I: BatchGetProfilePreviewRequest,
      O: BatchGetProfilePreviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns multiple user profile tags views.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.BatchGetProfileTags
     */
    batchGetProfileTags: {
      name: "BatchGetProfileTags",
      I: BatchGetProfileTagsRequest,
      O: BatchGetProfileTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns floating location for homeless user profiles.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.GetHomelessProfileLocation
     */
    getHomelessProfileLocation: {
      name: "GetHomelessProfileLocation",
      I: GetHomelessProfileLocationRequest,
      O: GetHomelessProfileLocationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns floating location for homeless user profiles in batch.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.BatchGetHomelessProfileLocation
     */
    batchGetHomelessProfileLocation: {
      name: "BatchGetHomelessProfileLocation",
      I: BatchGetHomelessProfileLocationRequest,
      O: BatchGetHomelessProfileLocationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns user id that belongs to specified email address.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.GetUserID
     */
    getUserID: {
      name: "GetUserID",
      I: GetUserIDRequest,
      O: GetUserIDResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns single user profile info.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.GetProfileInfo
     */
    getProfileInfo: {
      name: "GetProfileInfo",
      I: GetProfileInfoRequest,
      O: GetProfileInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns multiple user profile info.
     *
     * @generated from rpc gdx.profile.v1.ProfileAPI.BatchGetProfileInfo
     */
    batchGetProfileInfo: {
      name: "BatchGetProfileInfo",
      I: BatchGetProfileInfoRequest,
      O: BatchGetProfileInfoResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

